import {
  LetterbookSettingType,
  LetterbooksLibraryConditionType,
} from "features/Letterbooks/types";
import LetterbookUserBookShelfRow from "features/Letterbooks/components/cards/LetterbookUserBookShelfRow/LetterbookUserBookShelfRow";
import LetterbookTableRow from "features/Letterbooks/components/cards/LetterbookTableRow/LetterbookTableRow";
import LetterbookCurrentlyReadingRow from "features/Letterbooks/components/cards/LetterbookCurrentlyReadingRow/LetterbookCurrentlyReadingRow";
import LetterbookUserBookByStatusCard from "features/Letterbooks/components/cards/LetterbookUserBookByStatusCard/LetterbookUserBookByStatusCard";
import { slugIdConstants } from "types/UserBookStatusType";

const componentMap = {
  card: {
    // By Status
    [slugIdConstants["want-to-read"]]: LetterbookUserBookByStatusCard,
    [slugIdConstants["currently-reading"]]: LetterbookCurrentlyReadingRow,
    [slugIdConstants.read]: LetterbookUserBookByStatusCard,
    [slugIdConstants.paused]: LetterbookUserBookByStatusCard,
    [slugIdConstants["did-not-finish"]]: LetterbookUserBookByStatusCard,
    [slugIdConstants.ignored]: LetterbookUserBookByStatusCard,
  },
  shelf: LetterbookUserBookShelfRow,
  table: LetterbookTableRow,
};

export default function LibraryRowComponent(settings: LetterbookSettingType) {
  if (settings.view === "card") {
    const conditions = settings.conditions as LetterbooksLibraryConditionType;
    return (
      componentMap[settings.view][conditions.status_id] ||
      LetterbookUserBookByStatusCard
    );
  }
  return componentMap[settings.view];
}
